import { render } from "./VipCountdown.vue?vue&type=template&id=ce085da8&scoped=true"
import script from "./VipCountdown.vue?vue&type=script&lang=js"
export * from "./VipCountdown.vue?vue&type=script&lang=js"

import "./VipCountdown.vue?vue&type=style&index=0&id=ce085da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce085da8"]])

export default __exports__